import { t } from '@/core/localization';
import barcodeReadIcon from '@/core/svg/fa/barcode-read.svg';
import boxOpenIcon from '@/core/svg/fa/box-open.svg';
import boxesStackedIcon from '@/core/svg/fa/boxes-stacked.svg';
import chartTreeMapIcon from '@/core/svg/fa/chart-tree-map.svg';
import doNotEnterIcon from '@/core/svg/fa/do-not-enter.svg';
import dollyIcon from '@/core/svg/fa/dolly.svg';
import gearIcon from '@/core/svg/fa/gear.svg';
import handHoldingBoxIcon from '@/core/svg/fa/hand-holding-box.svg';
export const appSections = {
    crossdockingReceipt: {
        id: 'crossdockingReceipt',
        rootPath: 'crossdock/:crossDockId/receipt',
        getLinkTo: (crossDockId) => `/crossdock/${crossDockId}/receipt`,
        icon: barcodeReadIcon,
        title: `${t('receipt.label')} ${t('crossdocking.label').toLocaleLowerCase()}`,
        menuItemTitle: t('receipt.label'),
        groups: ['crossdocking'],
    },
    packing: {
        id: 'packing',
        rootPath: 'crossdock/:crossDockId/packing',
        getLinkTo: (crossDockId) => `/crossdock/${crossDockId}/packing`,
        icon: boxOpenIcon,
        title: t('packing.label'),
        groups: ['crossdocking'],
    },
    shipping: {
        id: 'shipping',
        rootPath: 'crossdock/:crossDockId/shipping',
        getLinkTo: (crossDockId) => `/crossdock/${crossDockId}/shipping`,
        icon: dollyIcon,
        title: t('shipping.label'),
        groups: ['crossdocking'],
    },
    crossdockingBlocked: {
        id: 'crossdockingBlocked',
        rootPath: 'crossdock/:crossDockId/blocked',
        getLinkTo: (crossDockId) => `/crossdock/${crossDockId}/blocked`,
        icon: doNotEnterIcon,
        title: t('blocked.section.title'),
        groups: ['crossdocking'],
    },
    picking: {
        id: 'picking',
        rootPath: 'location/:locationId/picking',
        getLinkTo: (locationId) => `/location/${locationId}/picking`,
        icon: handHoldingBoxIcon,
        title: t('picking.label'),
        groups: ['stock'],
    },
    stockReceipt: {
        id: 'stockReceipt',
        rootPath: 'location/:locationId/receipt',
        getLinkTo: (locationId) => `/location/${locationId}/receipt`,
        icon: barcodeReadIcon,
        title: `${t('receipt.label')} ${t('stock.label').toLocaleLowerCase()}`,
        groups: ['stock'],
    },
    stocks: {
        id: 'stocks',
        rootPath: 'location/:locationId/stocks',
        getLinkTo: (locationId) => `/location/${locationId}/stocks`,
        icon: boxesStackedIcon, // <i class="fa-duotone fa-solid fa-shelves-empty"></i>
        title: t('warehouses.label'),
        groups: ['stock'],
    },
    storage: {
        id: 'storage',
        rootPath: 'location/:locationId/storage',
        getLinkTo: (locationId) => `/location/${locationId}/storage`,
        icon: chartTreeMapIcon, //  faCubesStacked - is old variant.
        title: t('warehouse.addresses.label'),
        menuItemTitle: t('warehouse.addresses.short.label'),
        groups: ['stock'],
    },
    stockBlocked: {
        id: 'stockBlocked',
        rootPath: 'location/:locationId/blocked',
        getLinkTo: (locationId) => `/location/${locationId}/blocked`,
        icon: doNotEnterIcon,
        title: t('blocked.section.title'),
        menuItemTitle: t('blocked.section.title'),
        groups: ['stock'],
    },
    settings: {
        id: 'settings',
        rootPath: 'settings',
        getLinkTo: () => `/settings`,
        icon: gearIcon,
        title: t('settings.label'),
        groups: ['crossdocking', 'stock'],
    },
};
